import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take, tap } from 'rxjs/operators';
import { IOpsViewerMessagesService } from '../services/services';
import { IUserManagerService } from '../services/iUserManager.service';

@Injectable({ providedIn: 'root' })
export class GlobalAdminGuard implements CanActivate {
    constructor(
        private readonly userManagerService: IUserManagerService,
        private readonly messageService: IOpsViewerMessagesService,
        private readonly router: Router
    ) { }

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
        return this.userManagerService.getCurrentUser().pipe(
            take(1),
            map(user => !!user?.isGlobalAdmin),
            tap(isGlobalAdmin => {
                if (!isGlobalAdmin) {
                    this.messageService.warnMessage('User does not have permission to this feature.', '');
                    this.router.navigate(['/home']);
                }
            }),
            catchError(_error => {
                this.messageService.warnMessage('Could not verify permissions.', '');
                this.router.navigate(['/home']);
                return of(false);
            })
        );
    }
}